import styled, { css } from "styled-components";
import { responsive } from "../../theme/reponsive";

export const ModalWrapper = styled.div<{ visible?: boolean; mxh?: string }>`
   /* max-height: ${({ mxh }) => (mxh ? mxh : "60rem")}; */
   background: white;
   position: fixed;
   z-index: 4000;
   top: 53%;
   left: 50%;
   transform: translate(-50%, -50%);
   opacity: 0;
   visibility: hidden;
   border-radius: 8px;
   transition: top 250ms ease-in-out, opacity 250ms ease-in-out, visibility 250ms ease-in-out;
   box-shadow: -1px 2px 20px rgba(0, 0, 0, 0.1);
   /* overflow-y: scroll; */
   padding: 5rem;

   ${responsive("$small")`
   padding: 3rem;
   width: 95% !important;
`}

   ${responsive("$xsmall")`
   // padding: 5rem 3rem;
   // height: 50rem;
`}

   .icon {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10;
   }

   ${({ visible }) =>
      visible &&
      css`
         opacity: 1;
         visibility: visible;
         top: 55%;
         /* overflow-y: scroll; */
      `}
`;

export const RightModalWrapper = styled.div<{ visible?: boolean }>`
   height: 100%;
   width: 609px;
   background: white;
   position: fixed;
   z-index: 3000;
   left: 100%;
   transform: translate(-100%, -55%);
   opacity: 0;
   visibility: hidden;
   transition: top 250ms ease-in-out, opacity 250ms ease-in-out, visibility 250ms ease-in-out;
   box-shadow: -1px 2px 20px rgba(0, 0, 0, 0.1);
   .header-area {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 31px 26px;
      .header {
         display: flex;
         align-items: center;
         justify-content: space-between;
         .text {
            font-weight: 500;
            font-size: 20px;
         }
      }
   }
   .modal-body {
      height: calc(100%-124px) !important;
      width: 100%;
      padding: 31px 26px;
      margin-top: -1rem;
   }

   ${responsive("$small")`
      .header-area { 
       padding:2.5rem;
      }
      .modal-body { 
       padding:2.5rem;
      }
     width: 95% !important;
`}

   .icon {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 10;
   }

   ${({ visible }) =>
      visible &&
      css`
         opacity: 1;
         visibility: visible;
         top: 55%;
         /* overflow-y: scroll; */
      `}
`;
